import { Navigate, Outlet } from 'react-router-dom';
import { getToken } from '../../auth/token';
import Sidebar from './Sidebar';

export default function ProtectedLayout() {
  const token = getToken();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex min-h-screen bg-slate-50 dark:bg-slate-900 transition-colors duration-500">
      <Sidebar />
      <main className="flex-1 p-8 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}